export enum BusinessPlan {
  ESSENTIALS_MONTHLY = "essentials-monthly",
  ESSENTIALS_ANNUAL = "essentials-annual",
  PROFESSIONAL_MONTHLY = "professional-monthly",
  PROFESSIONAL_ANNUAL = "professional-annual",
}
